interface CatalogProduct {
  model: string;
  sub_category: string;
  head_length?: string;
  total_length?: string;
  iso_code?: string;
  order?: string;
  note?: string;
}

async function fetchCatalogData(): Promise<CatalogProduct[]> {
  try {
    const response = await fetch("/diamond-burs/diamond_burs.json");
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (e) {
    console.error("Could not load diamond burs catalog data:", e);
    return [];
  }
}

function renderProductCell(item: CatalogProduct): HTMLElement {
  const el = document.createElement("div");
  el.className = "cell product";

  const imgWrapper = document.createElement("div");
  imgWrapper.className = "product-image-wrapper";

  const imgEl = document.createElement("img");
  imgEl.src = `/diamond-burs/assets/${item.model}.png`;
  imgEl.className = "product-image";
  imgEl.loading = "lazy";
  imgEl.alt = item.model || "Diamond Bur";
  imgWrapper.appendChild(imgEl);
  el.appendChild(imgWrapper);

  const detailsEl = document.createElement("div");
  detailsEl.className = "product-details";

  detailsEl.innerHTML = `
    <div class="product-dims">
      ${item.head_length ? `<span>${item.head_length}</span>` : ""}
      ${item.total_length ? `<span>${item.total_length}</span>` : ""}
    </div>
    <div class="product-iso">${item.iso_code || ""}</div>
    <div class="product-model">${item.model || ""}</div>
    <div class="product-order">${item.order || ""}</div>
    ${item.note ? `<div class="product-note">${item.note}</div>` : ""}
  `;
  el.appendChild(detailsEl);

  return el;
}

async function init() {
  const data = await fetchCatalogData();
  const container = document.getElementById("catalog-container");
  if (!container) return;

  // Group products by sub_category
  const groupedProducts = data.reduce(
    (acc, item) => {
      const key = item.sub_category;
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    },
    {} as Record<string, CatalogProduct[]>,
  );

  const categoryColorMap: Record<string, string> = {
    "Standard 106-125μ": "var(--color-standard)",
    "Coarse 125-150μ": "var(--color-coarse)",
    "Fine 53-63μ": "var(--color-fine)",
    "Extra Fine 20-30μ": "var(--color-extrafine)",
    "Extra Coarse 150-183μ": "var(--color-extracoarse)",
  };

  // Render each category section
  Object.entries(groupedProducts).forEach(([categoryName, products]) => {
    // 1. Create section container
    const section = document.createElement("section");
    section.className = "category-section";

    // 2. Create colored header banner
    const cssVar = categoryColorMap[categoryName] || "var(--color-standard)";
    const banner = document.createElement("div");
    banner.className = "category-banner";
    banner.style.backgroundColor = cssVar;
    banner.textContent = categoryName;
    section.appendChild(banner);

    // 3. Create responsive product grid
    const grid = document.createElement("div");
    grid.className = "product-grid";
    products.forEach((p) => {
      grid.appendChild(renderProductCell(p));
    });

    section.appendChild(grid);
    container.appendChild(section);
  });
}

document.addEventListener("DOMContentLoaded", init);
